import { render } from "./AboutUsView.vue?vue&type=template&id=26393f6b"
import script from "./AboutUsView.vue?vue&type=script&lang=js"
export * from "./AboutUsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__